/* The registered entry point for the 2D contour view.
 *
 * Viewpoint mode only, for the same reason the surface view is - see the note there. */

import { connect } from '@ardoq/rxbeach';
import styled from 'styled-components';
import { ContourView } from './ContourView';
import { contourViewModel$ } from './viewModel$/contourViewModel$';

/**
 * Grows to fill the view pane, which is itself a `flex: 1` column with `flex-basis: 0`.
 *
 * A `height: 100%` box here has nothing definite to resolve against and collapses; growing as a
 * flex item does, and `min-height: 0` lets it shrink past its content so the canvas follows the
 * pane rather than forcing it open.
 */
const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ConnectedContourView = connect(ContourView, contourViewModel$);

export const ContourViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedContourView />
  </ViewRoot>
);
